import React from 'react';

import MainContent from '../components/layout/MainContent';

import Body from '../components/typography/Body';
import Caption from '../components/typography/Caption';
import Headline from '../components/typography/Headline';
import List from '../components/typography/List';
import ListItem from '../components/typography/ListItem';
import Subtitle from '../components/typography/Subtitle';
import Title from '../components/typography/Title';

import { createFetchingView } from '../helpers/views';

const lorem = `Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
proident, sunt in culpa qui officia deserunt mollit anim id est laborum.`;

class StaticPlaceholderView extends React.PureComponent {
  static pageTitle = 'Static Page Title';

  renderContent() {
    return (
      <MainContent
        id="StaticPlaceholderView"
        className="sk-fade-in-quarter-second"
      >
        <Title align="center">Static Placeholder View</Title>

        <Title>Title</Title>
        <Subtitle>Subtitle</Subtitle>
        <Headline>Headline</Headline>

        <Headline>Paragraphs</Headline>

        <Body>{lorem}</Body>
        <Caption>Caption Text</Caption>
        <Body>{lorem}</Body>

        <Headline>List</Headline>
        <List>
          <ListItem>List Item 1</ListItem>
          <ListItem>List Item 2</ListItem>
        </List>
      </MainContent>
    );
  }

  render() {
    if (this.props.isReady) {
      return this.renderContent();
    }

    return null;
  }
}

export default createFetchingView(StaticPlaceholderView);



// WEBPACK FOOTER //
// ./src/views/StaticPlaceholderView.js